import axiosInstance from './axiosInstance'

export const getSiteSurveyOptionById = (optionId) => {
  return axiosInstance.get(`/site-survey-options/${optionId}`)
}

export const getSiteSurveyOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/site-survey-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createSiteSurveyOption = (data) => {
  return axiosInstance.post('/site-survey-options', data)
}

export const updateSiteSurveyOption = (optionId, data) => {
  return axiosInstance.put(`/site-survey-options/${optionId}`, data)
}

export const deleteSiteSurveyOption = (optionId) => {
  return axiosInstance.delete(`/site-survey-options/${optionId}`)
}
